import { ChevronDown } from "lucide-react";
import { useState } from "react";
import Reveal from "@/components/Reveal";

const questions = [
  ["What is MyEnglish Lesson.ca?", "We offer specialized Canadian ESL group and individual lessons focused on practical daily conversation, workplace culture, and confidence building."],
  ["How are lessons conducted?", "All sessions take place live online with interactive practice, calendar scheduling, and clear next steps after every class."],
  ["Who are the classes built for?", "Newcomers, tourists, international students, and professionals who want Canadian English to feel natural in daily life and at work."],
  ["Can I start with one class?", "Yes. Group English Practice is $32 per session and a 1-on-1 Private Lesson is $55 per session. Single sessions never auto-renew: you pay per class you book, nothing else. You can choose a low-pressure first step before deciding on the 9-Class Private Pass Bundle at $390/month."],
  ["What does the private bundle include?", "The 9-Class Private Pass Bundle includes 9 full 1-on-1 private lessons every month at $390/month locked-in. It is designed entirely for maximum private immersion."],
  ["What is the Class Pass reward?", "Class Pass rewards eligible standard $32 Group Practice and $55 Private Lesson sessions with $20 back per class, up to 5 classes per month and 60 classes per year. It does not apply to the 9-Class Private Pass Bundle."],
  ["What if I need to cancel or reschedule?", <>Plans change — cancel or reschedule free up to 24 hours before class; within 24 hours the session is forfeited. Read the <a className="faq-inline-link" href="/terms" data-testid="faq-terms-policy-link">Terms &amp; Conditions</a> for the full policy.</>],
];

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="faq-section section-space" aria-labelledby="faq-title">
      <Reveal className="section-inner faq-inner">
        <div className="faq-intro">
          <div className="section-kicker">GOOD QUESTIONS</div>
          <h2 id="faq-title">Frequently asked questions.</h2>
          <p>Everything you need to know before joining a live Canadian English practice session.</p>
          <p className="faq-trust-note" data-testid="enrollment-count-faq-note"><strong>429+</strong> <span>Total Lessons Served</span></p>
        </div>
        <div className="faq-list">
          {questions.map(([question, answer], index) => {
            const isOpen = openIndex === index;
            return (
              <div className={`faq-item ${isOpen ? "is-open" : ""}`} key={question} data-testid={`faq-accordion-item-${index}`}>
                <button type="button" className="faq-trigger" onClick={() => setOpenIndex(isOpen ? -1 : index)} aria-expanded={isOpen} aria-controls={`faq-answer-${index}`} data-testid={`faq-toggle-${index}`}>
                  <span><b>0{index + 1}</b>{question}</span><ChevronDown size={18} />
                </button>
                <div id={`faq-answer-${index}`} className="faq-answer-grid" aria-hidden={!isOpen}><div className="faq-answer"><p>{answer}</p></div></div>
              </div>
            );
          })}
        </div>
      </Reveal>
    </section>
  );
};

export default FAQSection;
